import { FC, useId } from 'react';
import { IonPopover } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { InfoIcon } from '../theme/Icons';
import { BRAND, CHART_INK } from './insights/agencyChartTheme';

const useStyles = createUseStyles({
    button: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        flexShrink: 0,
        padding: 0,
        background: 'none',
        border: 0,
        font: 'inherit',
        color: BRAND.coralInk,
        cursor: 'pointer'
    },

    popover: {
        '--max-width': '280px',
        '--width': '280px'
    },

    body: {
        padding: '12px 14px',
        fontSize: 12.5,
        lineHeight: 1.55,
        color: CHART_INK.strongLabel
    }
});

/**
 * Why an agency can see a client's name but little else, behind a mark beside their row.
 *
 * A standing fact about access rather than news: stated in full under every care map, it crowded
 * the list it was explaining. A button rather than a hover target, so a touch screen and a keyboard
 * can both reach it.
 */
export const ClientAccessTip: FC = () => {
    const classes = useStyles();
    const triggerId = `client-access-${useId()}`;

    return (
        <>
            <button
                id={triggerId}
                type="button"
                className={classes.button}
                data-id="client-access-tip"
                aria-label="Why this client's details are limited"
            >
                <InfoIcon color="inherit" />
            </button>

            <IonPopover
                className={classes.popover}
                trigger={triggerId}
                triggerAction="click"
                side="bottom"
                alignment="end"
                showBackdrop={false}
                dismissOnSelect
            >
                <div className={classes.body} data-id="client-access-tip-body">
                    This existing Innerhive profile is not shared with your organization, so your access is very
                    limited. Request access from the client to gain full access.
                </div>
            </IonPopover>
        </>
    );
};
